import { Card } from 'react-bootstrap';
import { useState, useEffect } from "react";
import Calendar from './Calendar';

function RightSidePage() {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setCurrentDate(new Date()), 1000);
    return () => clearInterval(interval); // Vyčistenie intervalu
  }, []);

  return (
    <div>
      {/* Aktuálny dátum a čas */}
      <Card className="text-center">
        <Card.Body>
          <Card.Title>Aktuálny dátum a čas</Card.Title>
          <Card.Text>
            {currentDate.toLocaleDateString()} <br />
            {currentDate.toLocaleTimeString()}
          </Card.Text>
        </Card.Body>
      </Card>

      <Card className="text-center mt-3">
        <Card.Body>
          <Card.Title>Meniny dnes</Card.Title>
          <Card.Text>
            <Calendar />
          </Card.Text>
        </Card.Body>
      </Card>

      <Card className="text-center mt-3">
        <Card.Body>
          <Card.Title>Posledná aktualizácia</Card.Title>
          <Card.Text>22.10.2024</Card.Text>
        </Card.Body>
      </Card>

      <Card className="text-center mt-3">
        <Card.Body>
          <Card.Title>Vytvoril</Card.Title>
          <Card.Text>Peter Kizek</Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}

export default RightSidePage;
